var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-dialer-common-page",
    {
      staticClass: "app-dialer-keypad-page",
      attrs: {
        title: _vm.$t("hitl.modules.dialer.keypad-popup-title"),
        "is-disabled": _vm.isDisabled,
      },
      on: {
        "go-back": function ($event) {
          return _vm.$emit("go-back", $event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "keypad-page-content" },
        [
          _c("app-dialer-keypad", {
            attrs: {
              size: "mobile",
              dial: _vm.dial,
              "is-disabled": _vm.isDisabled,
            },
            on: { "key-click": _vm.onKeyClick },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "actions" }, [
            _c(
              "div",
              {
                staticClass: "icon-button is-mobile",
                on: { click: _vm.onBackspaceClick },
              },
              [_c("or-icon", { attrs: { icon: "backspace" } })],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }